import { usePersonalizedDescriptions } from '../hooks/usePersonalizedDescriptions';

/** Mounted once so the descriptions query is in flight before the cards render. */
export const PersonalizedDescriptionsPrefetch = () => {
  usePersonalizedDescriptions();
  return null;
};
//# sourceMappingURL=PersonalizedDescriptionsPrefetch.js.map